import React from "react";
import Play_Icon from "../../../../assets/new/play_icon.png";
import Pause_Icon from "../../../../assets/new/pause_icon.png";
export default function InsPH() {
  return (
    <>
      <h1>Ano ang Savings?</h1>
      <p style={{ marginTop: "1rem", fontSize: "1rem" }}>
        Kumusta! Welcome sa Quick Learning Tool No. 5: Ano ang Savings?
        <br />
        <br />
        Ang pag-iipon ay isang malaking tulong sa ating kabutihang pinansyal,
        nagbibigay ng lakas sa pag-abot ng mga pangarap sa hinaharap at pagharap
        sa mga biglang gastusin sa pamamagitan ng pagtabi ng bahagi ng ating
        kita.
      </p>
      <br />
      <br />
      <h2>Gabay</h2>
      <p style={{ marginTop: "1rem", fontSize: "1rem" }}>
        Makakakita ka ng tatlong mga vendor na maaaring i-click sa mapa. I-click
        muna ang "Mareng Risa: Rice Dealer" vendor para simulan ang iyong
        learning journey. Sundan ang mga hakbang na ito ayon sa tamang
        pagkakasunod-sunod:
        <br />
        <br />
        You will find three (3) clickable vendors on the map. Click on "Mareng
        Risa: Rice Dealer" vendor first to start the learning journey. Follow
        this order accordingly: <br />
        <br />
        1. Mareng Risa: Rice Dealer <br />
        2. Madam Burda: Handicraftsman <br />
        3. Sir Manny: Bank Manager <br /> <br />
        Kapag na-click mo na ang isang vendor, magbubukas ang isang usapan.
        Basahin ito nang mabuti. <br /> <br /> May sasagutan kang
        multiple-choice questions rito na may kinalaman sa basic na konsepto ng
        loan. Sagutin lamang ang mga tanong para makapagpatuloy. <br /> <br />{" "}
        Kapag kailangan mong huminto, i-click ang icon na ito{" "}
        <img src={Pause_Icon} style={{ width: ".65rem" }} /> . Ito ay
        pansamantalang titigil sa kasalukuyang usapan. I-click ang{" "}
        <img src={Play_Icon} style={{ width: ".65rem" }} /> upang magpatuloy
        mula sa kung saan ka huling huminto.
        <br /> <br />
        {/* Finally, click on the "Finish" button once you reach the end of
        conversation with "Sir Manny: Bank Manager" to conclude the interactive
        activity. */}
      </p>
    </>
  );
}
